import {
    SET_BLOGS,
    SET_CURRENT_BLOG,
    DELETE_BLOG,
    CATEGORY_ADD,
    CATEGORY_DELETE,
    CATEGORY_UPDATE,
    TEAM_MEMBER_DELETE,
    TEAM_MEMBER_ADD
  } from '../actions/blogsActions';

  const initialState = {
    loaded: false,
    blogs: [],
    blog: {
      _id: '',
      owner: '',
      domain: '',
      title: '',
      slogan: '',
      categories: [],
      collaborators: []
    }
  };

  export default function (state = initialState, action) {
    switch (action.type) {
      case SET_CURRENT_BLOG: return onSetCurrentBlog(state, action);
      case SET_BLOGS: return onSetBlogs(state, action);
      case DELETE_BLOG: return onDeleteBlog(state, action);
      case CATEGORY_ADD: return onCategoryAdd(state, action);
      case CATEGORY_UPDATE: return onCategoryUpdate(state, action);
      case CATEGORY_DELETE: return onCategoryDelete(state, action);
      case TEAM_MEMBER_DELETE: return onTeamMemberDelete(state, action);
      case TEAM_MEMBER_ADD: return onTeamMemberAdd(state, action);
      default:
        return state;
    }
  }

  const onSetCurrentBlog = (state, action) => {

    if(action.blog._id) {
      localStorage.setItem('blog', action.blog._id)
    }

    let blog = {
      ...initialState.blog
    };

    if(action.blog) {
      blog = { ...action.blog }
    }

    return {
      ...state,
      loaded: true,
      blog: {
        ...blog,
        categories: action.blog.categories.filter( () => true ),
        collaborators: action.blog.collaborators.filter( () => true )
      }
    };
  }

  const onSetBlogs = (state, action) => {

    return {
      ...state,
      loaded: true,
      blogs: action.blogs ? [...action.blogs] : [] };
  }

  const onCategoryAdd = (state, action) => {

    const { category } = action;
    const newCategoriesArray = state.blog.categories.filter( () => true );
    newCategoriesArray.push(category);

    return {
      ...state,
      blog: {
        ...state.blog,
        categories: newCategoriesArray,
        collaborators: state.blog.collaborators.filter( () => true )
      }
    };
  }

  const onCategoryUpdate = (state, action) => {

    const { category } = action;

    const newCategoriesArray = state.blog.categories.filter( () => true );

    for(let i in newCategoriesArray) {
      if(newCategoriesArray[i]._id === category._id) {
        Object.assign(newCategoriesArray[i], category);
      }
    }

    return {
      ...state,
      blog: {
        ...state.blog,
        categories: newCategoriesArray,
        collaborators: state.blog.collaborators.filter( () => true )
      }
    };
  }

  const onCategoryDelete = (state, action) => {

    const { id } = action;

    return {
      ...state,
      blog: {
        ...state.blog,
        categories: state.blog.categories.filter( (category) => category._id !== id ),
        collaborators: state.blog.collaborators.filter( () => true )
      }
    };
  }

  const onTeamMemberDelete = (state, action) => {

    const { username } = action;

    return {
      ...state,
      blog: {
        ...state.blog,
        categories: state.blog.categories.filter( () => true ),
        collaborators: state.blog.collaborators.filter( (collaborator) => collaborator.username !== username )
      }
    };
  }

  const onTeamMemberAdd = (state, action) => {

    const { username, role } = action;

    const collaborator = {
      username,
      role
    }

    const newCollaborators = state.blog.collaborators.filter( () => true );
    newCollaborators.push(collaborator);

    return {
      ...state,
      blog: {
        ...state.blog,
        categories: state.blog.categories.filter( () => true ),
        collaborators: newCollaborators
      }
    };
  }

  const onDeleteBlog = (state, action) => {

    let blog = Object.assign({}, initialState.blog);

    const filteredBlogs = state.blogs.filter( blog => blog._id !== action.id )
    if(filteredBlogs.length > 0) {
      blog = Object.assign({}, filteredBlogs[0]);
    }

    localStorage.setItem('blog', blog._id)

    return {
      blog: blog,
      blogs: filteredBlogs,
      loaded: true
    };
  }
